import classnames from 'classnames'
import { useEffect, useState } from 'react'
import { requestGetEnrollmentsExist } from '../../../../actions/enrollmentActions'
import { useDispatch, useSelector } from 'react-redux'
import { COMMON_ERRORS } from '../../../../misc/Constants'
import { toast } from 'react-toastify'
import { getCommunityCategories } from '../../../../actions/programCategoryActions'
import FinancialPerformanceWidget from './financial-performance-widget/FinancialPerformanceWidget'
import ProgramsEnrollmentsActivity from './programs-enrollments-activity-widget/ProgramsEnrollmentsActivityWidget'
import ProgramCategoryPackageBreakdownWidget from './program-category-package-breakdown-widget/ProgramCategoryPackageBreakdownWidget'
import MarketingAnalyticsWidget from './marketing-analytics-widget/MarketingAnalyticsWidget'

import classes from './BusinessDashboard.module.scss'
import { getProgramsFilterOptions } from '../../../../actions/programActions'

const BusinessDashboard = () => {
  const dispatch = useDispatch()

  const currentUser = useSelector(state => state.user.current_user)
  const [communityHasEnrollments, setCommunityHasEnrollments] = useState()
  const [isLoading, setIsLoading] = useState(true)

  const communityId = currentUser.communities[0].id

  useEffect(() => {
    Promise.all([
      requestGetEnrollmentsExist(communityId)
        .then(res => setCommunityHasEnrollments(res.data.exists)),
      dispatch(getCommunityCategories())
        .unwrap(),
      dispatch(getProgramsFilterOptions())
        .unwrap(),
    ]).then(() => setIsLoading(false))
      .catch(() => toast.error(COMMON_ERRORS[500]))
  }, [communityId, dispatch])

  return (
    <div className={classnames(classes.businessDashboardContainer, 'd-flex flex-column align-items-center')}>
      <FinancialPerformanceWidget communityHasEnrollments={communityHasEnrollments} isLoadingEnrollmentsPresence={isLoading} />
      <ProgramsEnrollmentsActivity />
      <ProgramCategoryPackageBreakdownWidget />
      <MarketingAnalyticsWidget />
      <div className={classes.spacer} />
    </div>
  )
}

export default BusinessDashboard
